import {
  documentItemTagLabelStyles,
  documentItemTagWrapperStyles,
} from '../DocumentItemTag.styles';

export const discriminatorTagWrapperSx = documentItemTagWrapperStyles;

export const discriminatorValueSx = {
  ...documentItemTagLabelStyles,
  maxWidth: '128px',
};

export const discriminatorQueryMarkSx = {
  flexShrink: 0,
  opacity: 0.7,
};
